<template>
    <div
        class="md-search-result template4"
        :class="{ 'show-below': showMap && !hideBelow }"
        :style="{
            height: showMap ? '' : loading ? '100vh' : 'auto'
        }"
    >
        <div
            class="map-result-container"
            v-show="showMap"
        >
            <SearchMap
                :showMap="showMap"
                v-if="mapCenter && hasMap && inBeforeMount && showOrShownMap "
                :center="mapCenter"
                :zoom="drawingZoom || (mapData && mapData.zoom) || 12"
                :boundary="boundary"
                :geometry="geometry"
                :showSchool="showSchool"
                :class="isSold ? 'hide-school' : ''"
                :mapSearchText="mapSearchText"
                :mapDrawTip="mapDrawTip"
                :ref="onSearchMapRef"
            />
            <i
                class="btn-collapse iconfont icon-expand"
                v-if="!forCMS && !showInsight && isMixed"
                :class="layout === 'mixed' ? '' : 'collapse'"
                @click="collapseList"
            ></i>
        </div>
        <div
            :class="{
                'search-result-container': true,
                'mg-container':
                    layout === 'normal' && gridOrListType === 'list',
                [containerCls]: true,
                'search-result-container-area-empty': isFeatureAreaPage && isShowEmpty
            }"
        >
            <div class="drawing-mask" v-if="drawing"></div>
            <div class="search-result-header">
                <site-h1 class="search-text m0">
                    <span>{{ searchCount }}</span> <span>{{ searchText }}</span>
                </site-h1>
                <div class="search-choose" v-if="!hideSearchChoose">
                    <div class="search-sort">
                        <Select
                            :options="listingSortOptions"
                            :value="sort"
                            @change="onSortChange"
                            :dropdownIcon="
                                isMobileSize
                                    ? 'icon-v4-arrow'
                                    : 'icon-small-down'
                            "
                        />
                    </div>
                    <div class="search-switch">
                        <div
                            class="switch-item"
                            v-for="item in modes"
                            :key="item.name"
                            @click="switchView(item.name)"
                        >
                            <span
                                class="name"
                                :class="{
                                    active: item.active,
                                    'side-active': item.sideActive
                                }"
                            >{{
                                $t(
                                    'md-search-result.' +
                                        item.name.toLowerCase()
                                )
                            }}</span>
                            <i
                                :class="
                                    'iconfont ' +
                                        icons[item.name] +
                                        (item.active ? ' active' : '') +
                                        (item.sideActive ? ' side-active' : '')
                                "
                            ></i>
                        </div>
                    </div>
                </div>
                <div
                    class="refine-search"
                    v-if="
                        global.pageKey === 'featured-area-search' &&
                            featureAreaSearchRefineLink &&
                            !isMobileSize
                    "
                >
                    <a
                        :href="featureAreaSearchRefineLink"
                        rel="noopener noreferrer"
                    ><i class="iconfont icon-community"></i>{{ $t('featured-area-search.refineSearch') }}</a>
                </div>
            </div>
            <component
                v-if="locationType !== 'none' && !forCMS && !wordPressSSR && !onlyShowHouses"
                :is="crumbsCom"
                :breadCrumbs="breadCrumbs"
                :isShowEmpty="isShowEmpty"
                :showMap="showMap"
            />
            <div
                class="search-result mg-scrollbar"
                v-if="showGrid || showList"
                ref="result"
            >
                <template
                    v-if="
                        result && result.listings && result.listings.length > 0
                    "
                >
                    <HouseList
                        v-if="showList && !showMap"
                    />
                    <HouseBriefList
                        v-if="showList && showMap"
                        :isInMap="showMap"
                        @activeMarker="activeMarker"
                    />
                    <HouseGrid
                        v-if="showGrid"
                        :class="{ small: showMap, 'full-screen': true }"
                        :isInMap="showMap"
                        :showCheckbox="showMap"
                        @activeMarker="activeMarker"
                    />
                    <Page
                        :totalPage="result.totalPage"
                        :pageSize="pageSize"
                        :pageNum="page"
                        @pageChange="pageChange"
                    />
                    <MlsDisclaimer v-if="wordPressSSR" theme="fashion" />
                </template>

                <template v-else-if="!loading">
                    <component
                        :is="emptyCompName"
                        class="search-empty-status"
                        :isMobileSize="isMobileSize"
                        :theme="theme"
                        :isDisabledEmptyZoomOut="isDisabledEmptyZoomOut"
                        :showMap="showMap"
                        :emptyImg="emptyImg"
                        :isFeatureAreaPage="isFeatureAreaPage"
                        @handlerZoomOut="handlerZoomOut"
                    />
                </template>
                <template v-if="!onlyShowHouses">
                    <template
                        v-if="
                            locationType === 'single' &&
                                !forCMS &&
                                !wordPressSSR
                        "
                    >
                        <ExploreListings
                            :theme="
                                containerCls === 'right'
                                    ? 'template4-listing-map'
                                    : 'template4-listing-list'
                            "
                            :breadCrumbs="breadCrumbs"
                            :keywords="keywords"
                            :averageData="averageData"
                        />
                        <ExploreNbr
                            :theme="
                                containerCls === 'right'
                                    ? 'template4-listing-map'
                                    : 'template4-listing-list'
                            "
                            :breadCrumbs="breadCrumbs"
                        />
                    </template>
                    <div class="quick-search" v-if="hideBelow && hideQuickSearch">
                        <module-layout
                            v-if="quickSearchData"
                            :id="quickSearchData.id"
                            :mdData="quickSearchData"
                            :inner="true"
                            v-show="showMap"
                            class="inner"
                        />
                    </div>
                    <div class="search-seo-template4">
                        <module-layout
                            v-if="searchSeoData"
                            :id="searchSeoData.id"
                            :mdData="searchSeoData"
                            :inMapList="searchSeoData"
                            :inner="true"
                            v-show="showMap"
                            class="inner"
                        />
                    </div>
                    <module-layout
                        :inner="true"
                        v-if="footerData"
                        :id="footerData.id"
                        :mdData="footerData"
                        v-show="showMap"
                        class="inner"
                    />
                </template>
                <div
                    class="refine-search"
                    v-if="
                        global.pageKey === 'featured-area-search' &&
                            featureAreaSearchRefineLink &&
                            isMobileSize
                    "
                >
                    <a
                        :href="featureAreaSearchRefineLink"
                        rel="noopener noreferrer"
                    ><i class="iconfont icon-community"></i>{{ $t('featured-area-search.refineSearch') }}</a>
                </div>
            </div>
            <div class="loading" v-show="loading">
                <Loading />
            </div>
        </div>
        <Insight
            v-if="showInsight && fetchedSearchData && !wordPressSSR"
            :searchCount="searchCount"
            :breadCrumbs="breadCrumbs"
            :hideBelow="hideBelow"
        />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import Core from '../index';
import SearchMap from './search-map.vue';
import Insight from './components/insight';
import Crumbs from './components/crumbs.vue';
import SubTitle from './components/sub-title';
import ExploreListings from '../explore-listings.vue';
import ExploreNbr from '../explore-nbr.vue';
import { getAsyComponent } from '@/common/utils/load-module.js';

const CRUMBS_COMPONENT_MAP = {
    single: Crumbs,
    multi: SubTitle,
    none: {}
};

export default {
    mixins: [Core],
    data: function() {
        return {
            theme: 'template4',
            showAllIcons: false,
            icons: {
                map: 'icon-fat-map',
                grid: 'icon-grid-fill',
                list: 'icon-list-fill'
            }
        };
    },
    computed: {
        crumbsCom() {
            return CRUMBS_COMPONENT_MAP[this.locationType];
        },
        emptyImg() {
            return this.showMap ? 'https://cdn.chime.me/image/fs/sitebuild/2023920/19/original_782b9007-2740-46c3-9ce8-0fd263960feb.png' : 'https://cdn.chime.me/image/fs/sitebuild/2023913/1/original_53a5129e-900b-469d-bf57-6d6dbcbb859e.png'
        }
    },
    components: {
        HouseGrid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v3_grid"*/ '@/modules/md-house/grid-v3/grid.vue'
            )),
        HouseList: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/list-v3_list"*/ '@/modules/md-house/list-v3/list.vue'
            )),
        HouseBriefList: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/list-v3_brief-list"*/ '@/modules/md-house/list-v3/brief-list/index.vue'
            )),
        Page: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination"*/ '@/components/pagination/index.vue'
            )),
        SearchMap,
        Insight,
        ExploreListings,
        ExploreNbr
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-search-result.template4 {
    display: flex;
    position: relative;
    overflow: hidden;
    .search-result .mls-declaimer-container {
        padding: 20px;
    }
    .map-result-container {
        flex: 1;
        background: #a6a9b2;
        position: relative;
        .btn-collapse {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: #242a3d;
            height: 50px;
            width: 24px;
            text-align: center;
            color: #bfc9e4;
            cursor: pointer;
            font-weight: bold;
            &:before {
                font-size: 16px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(-90deg);
            }
            &.collapse:before {
                transform: translate(-50%, -50%) rotate(90deg);
            }
            @include media-800 {
                display: none;
            }
        }
    }
    .search-result-container {
        margin-top: 12px;
        position: relative;
        min-height: 300px;
        &.search-result-container-area-empty {
            min-height: 160px;
        }
        &.mg-container {
            overflow: visible;
        }
        &:not(.mg-container) {
            width: 100%;
            margin-left: 20px;
            margin-right: 20px;
            @include media-600 {
                margin-left: 0;
                margin-right: 0;
            }
        }
        &.right {
            height: 100%;
            width: 700px;
            margin: 0;
            display: flex;
            flex-direction: column;
            background: #242a3d;
            color: white;
            .search-result-header {
                padding: 10px 20px 0;
                .search-choose {
                    padding: 10px 0;
                    .search-sort {
                        .sort-by {
                            font-size: 14px;
                            color: #505050;
                        }
                        .title {
                            /* color: white; */
                            color: #8b93a7;
                        }
                    }
                }
                .search-text {
                    font-size: 18px;
                    line-height: 1.33;
                    margin-right: 10px;
                    padding: 10px 0;
                    color: #fff;
                }
            }
            .crumbs.template4 {
                padding-left: 20px;
                padding-right: 20px;
                .content {
                    background-color: #33394c;
                    .left {
                        .crumb_item {
                            color: #8b93a7;
                            .crumb_inner.is-link {
                                color: #fff;
                            }
                        }
                    }
                    .right {
                        color: #fff;
                    }
                }
            }
            .explore-nbr,
            .explore-listings,
            .quick-search {
                padding-left: 20px;
                padding-right: 20px;
            }
            .sub_title.template4 {
                padding-left: 20px;
                padding-right: 20px;
                padding-top: 0;
                padding-bottom: 10px;
            }
            .search-result {
                flex: 1;
                overflow-y: auto;
                overflow-x: hidden;
                margin: 0;
                .house-grid {
                    margin-top: 0;
                }
            }
            .comp-pagination .page > li:not(.active) {
                color: white;
                background-color: initial;
                &.page-num {
                    position: relative;
                }
                &.page-num:hover::after {
                    content: '';
                    background-color: #ffffff0d;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    pointer-events: none;
                }
            }
            .loading {
                .loading-box {
                    top: 50%;
                }
            }
        }
        &.big-map {
            width: 0;
            margin: 0;
            position: relative;
            .search-result-header {
                position: absolute;
                right: 80px;
                top: 20px;
                padding: 5px 10px;
                background-color: white;
                display: none;
                .search-text,
                .search-choose .search-sort {
                    display: none;
                }
                .search-choose .search-switch {
                    display: flex;
                    height: auto;
                    line-height: unset;
                    i {
                        margin: 0;
                        font-size: 20px;
                        padding: 0;
                    }
                    .switch-item {
                        &:first-of-type {
                            margin-left: 0px;
                        }
                        .name {
                            display: none;
                        }
                    }
                }
            }
            .search-result {
                display: none;
            }
        }
        &.insight {
            width: 0;
            overflow: hidden;
            margin-left: 0;
            margin-right: 0;
        }
        .search-result-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .search-text {
                font-family: var(--font-bold);
                font-size: 30px;
                color: #4a4a60;
                flex-grow: 100;
                line-height: 40px;
            }
            .search-choose {
                display: flex;
                align-items: center;
                flex-grow: 1;
                justify-content: space-between;
                .search-sort {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    .sort-by {
                        color: #8b93a7;
                        margin-right: 20px;
                    }
                    .select {
                        position: relative;
                        color: #4a4a60;
                        cursor: pointer;
                        .name {
                            display: none;
                        }
                        .title {
                            display: flex;
                            align-items: center;
                            @include media-800 {
                                color: #8b93a7;
                            }
                            @include media-min-800 {
                                .dropdown_icon {
                                    font-weight: bold;
                                    font-size: 18px;
                                }
                            }

                            .text {
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-family: var(--font-medium) !important;
                                cursor: pointer;
                            }
                        }
                        ul {
                            position: absolute;
                            top: 100%;
                            background-color: white;
                            border: solid 1px var(--color-border);
                            z-index: var(--level-medium);
                            padding: 5px 0;
                            li {
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                padding: 0 10px;
                                line-height: 32px;
                                font-size: 14px;
                                color: var(--color-label);
                                position: relative;
                                &.selected {
                                    padding-right: 40px;
                                    em {
                                        position: absolute;
                                        right: 10px;
                                        top: 50%;
                                        transform: translateY(-50%);
                                    }
                                    @include color-theme('color');
                                }
                                &:hover {
                                    background-color: #f6f7fb;
                                    @include color-theme('color');
                                }
                            }
                        }
                    }
                }
                .search-switch {
                    margin-left: 6px;
                    display: flex;
                    align-items: center;
                    .switch-item {
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: 16px;
                        width: auto;
                        height: 20px;
                        color: #8b93a7;
                        cursor: pointer;
                    }
                    .name {
                        text-transform: capitalize;
                        font-family: var(--font-medium);
                    }
                    i {
                        font-size: 20px;
                    }
                    .side-active {
                        @include color-theme('color');
                    }
                    .active {
                        @include color-theme('color');
                    }
                }
            }
        }
        .search-result {
            /* margin-top: 40px; */
            margin-top: 5px;
            .house-list:not(.brief-list) {
                margin-top: -20px;
            }
        }
        .drawing-mask {
            width: 100%;
            height: 100%;
            background: rgba(218, 218, 218, 0.8);
            position: absolute;
            z-index: var(--level-subhigh);
        }
        .loading {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.9);
            z-index: var(--level-sublow);
            overflow: hidden;
            .loading-box {
                position: absolute;
                top: 200px;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    .insight {
        width: 700px;
        height: 100%;
        overflow: auto;
        @include media-800 {
            background: #fff;
            width: 100%;
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: calc(var(--level-subhigh) - 2);
        }
    }
    /* &.show-below {
        height: 650px;
    } */
    @include media-800 {
        margin: 0;
        padding: 0;
        .search-result-container {
            margin: 20px auto 0;
            .search-result-header {
                margin: 0;
                padding: 0 15px;
                flex-wrap: nowrap;
                .search-text {
                    font-size: 15px;
                    line-height: 16px;
                    margin-bottom: 0;
                    @include ellipsis();
                    flex: 1;
                }
                .search-choose {
                    flex: none;
                    margin-left: 10px;
                    .search-sort {
                        font-size: 12px;
                        .sort-by {
                            display: none;
                        }
                        .title {
                            font-size: 14px;
                        }
                        .dropdown_icon {
                            font-size: 8px;
                            margin-left: 10px;
                        }
                        .list-panel {
                            left: auto;
                            right: 0;
                        }
                    }
                    .search-switch {
                        display: none;
                    }
                }
            }
            .search-result {
                margin-top: 15px;
            }
        }
        /* &.show-below {
            height: 550px;
        } */
    }
}
.search-seo-template4 {
    &.md-search-seo {
        margin-top: 80px;
    }
    .seo-module-box {
        position: relative;
        &::before {
            position: absolute;
            content: '';
            height: 1px;
            left: 15px;
            right: 15px;
            top: -50px;
            background: #3f4965;
            z-index: 1;
        }
    }
    .search-seo {
        .title {
            &.in-map-list {
                color: #fff !important;
            }
        }
        .anchor {
            &.in-map-list {
                color: #8195bd !important;
                &:hover {
                    color: #4c84ff !important;
                }
            }
        }
        .action {
            &.in-map-list {
                color: #4c84ff !important;
            }
            .icon {
                .iconfont {
                    &.in-map-list {
                        color: #4c84ff !important;
                    }
                }
            }
        }
    }

    .md-footer,
    .md-footer.classic.inner {
        z-index: 1;
        width: 100%;
        .mls-declaimer-container {
            padding: 30px 20px 0;
            @include media-800 {
                padding: 10px 15px 0;
            }
        }

        .footer-container {
            padding: 15px 20px;
            @include media-800 {
                padding: 10px 15px;
            }
        }
    }
}
.md-search:not(.mobile) .md-search-result.template1 {
    height: 600px;
    flex-basis: 600px;
}
</style>
